import classNames from 'classnames';
import { Button } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { TestBem } from '../../../service/TestBem';
import { Shape2, Shape2Icon } from '../../Shape2/Shape2';

import './PhrasesSelectorControlButtons.css';

export interface PhrasesSelectorControlButtonsProps {
    disabled?: boolean;
    onAccept: () => void;
    onReject: () => void;
}

const BLOCK = 'phrases-selector-control-buttons';

export const PhrasesSelectorControlButtons: React.FunctionComponent<PhrasesSelectorControlButtonsProps> = ({
    disabled,
    onAccept,
    onReject
}) => {
    return (
        <div className={Bem.cls(BLOCK)}>
            <Button
                disabled={disabled}
                cls={classNames(Bem.cls(BLOCK, 'button'), TestBem.cls(BLOCK, 'accept-btn'))}
                theme="normal"
                size="s"
                onClick={onAccept}
            >
                <Shape2 width={10} height={10} icon={Shape2Icon.tick} />
            </Button>
            <Button cls={Bem.cls(BLOCK, 'button')} theme="normal" size="s" onClick={onReject}>
                <Shape2 width={10} height={10} icon={Shape2Icon.cross} />
            </Button>
        </div>
    );
};
